import { useFormikContext } from "formik";
import Box from "../../../components/layout/Box";
import { AutocompleteInput } from "./private/AutocompleteInput";
import { FormValues } from "../../Form";
import { Text } from "../../../components/typography/Text";
import Heading from "../../../components/typography/Heading";
import { SimulatorLayout, TotalSteps } from "./private/SimulatorLayout";
import { TypePicker } from "../../../components/form/TypePicker";

const AddressesStepContent = () => {
  const { values, setFieldValue } = useFormikContext<FormValues>();
  const is_home_address_filed = Boolean(values.addresses.home.label.length > 0);
  const is_work_address_filed = Boolean(values.addresses.work.label.length > 0);
  const is_weekly_comutes_filed = Boolean(values.addresses.weekly_comutes > 0);
  const should_unlock_submit: boolean = is_weekly_comutes_filed && is_home_address_filed && is_work_address_filed;

  // total steps
  const total = TotalSteps;
  const increment = (1/total) * 400;
  let counterProgress = (0/total) * 400;

  if (is_home_address_filed) {
    counterProgress += increment;
  }
  if (is_work_address_filed) {
    counterProgress += increment;
  }
  if (is_weekly_comutes_filed) {
    counterProgress += increment;
  }

  return (
    <SimulatorLayout
      isFirstStep
      isLastStep={false}
      isCtaDisabled={!should_unlock_submit}
      dynNumber={counterProgress}
      // isCtaDisabled={true}
      onCtaClick={() => setFieldValue("addresses.submitted", true)}
    >
      <Box padding={{ inline_end: "xl", inline_start: "xl" }}>
        <Box col>
          <Heading marginY="m0" size="h5" uppercase="true">Votre trajet</Heading>
          <Text >Votre domicile (N°, Rue, Code Postal)</Text>
          <AutocompleteInput 
            input_name="home" 
          />
        </Box>
        <Box 
          col 
          // hidden={!should_display_work_address_input}
          hidden={false}
        >
          <Text>Votre travail (N°, Rue, Code Postal)</Text>
          <AutocompleteInput
            input_name="work"
            proximity={[
              values.addresses.home.longitude,
              values.addresses.home.latitude,
            ]}
          />
        </Box>
        <Box 
          // hidden={!should_display_weekly_comutes_input}
          hidden={false}
          
        >
          <hr style={{  border: "1px solid var(--color-n-200)", margin: "20px 0px"}} />
          <Heading marginT="m1" size="h5" uppercase="true">Fréquence</Heading>
          <TypePicker.Root fieldName="addresses[weekly_comutes]">
            <TypePicker.Label as={Text}>
              Combien de fois par semaine seriez-vous prêt(e) à faire ce trajet aller-retour
              en vélo ?
            </TypePicker.Label>
            <TypePicker.OptionsGroup direction="row">
              {["1", "2", "3", "4", "5", "6", "7"].map((value) => (
                <TypePicker.Option round={true} value={value}>{value}</TypePicker.Option>
              ))}
            </TypePicker.OptionsGroup>
          </TypePicker.Root>
          <Text color="n-400">
            Vous effectuez ce trajet aller-retour <span style={{ color: 'var(--color-n-900)', fontWeight: 'bold' }}>{values.addresses.weekly_comutes}</span> fois par semaine</Text>
        </Box>
      </Box>
      
    </SimulatorLayout>
  );
};

export { AddressesStepContent };
